// The primary action's shape, shared by ContinueButton and the finish page's
// Links. Full width on a phone; on a desktop card a centered, sized button.
//
// A plain (non-"use client") module on purpose: a Server Component that
// imports a string from a "use client" file gets a client REFERENCE, not the
// string, and `cn()` silently drops it. That is how the finish page's buttons
// lost this class before it moved here.
export const CONTINUE_CLASS =
  "h-13 w-full rounded-xl text-base md:mx-auto md:w-auto md:min-w-80 md:px-10";
